import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "helperText", "multiple", "maxFiles", "placeholder", "multiFilePlaceholder", "enablePreview"];
import React from "react";
var __jsx = React.createElement;
import { useState, useCallback } from "react";
import { useFormContext, Controller } from 'react-hook-form';
import Upload from "@/components/Upload/Upload";
// @FIXME: should fix single file preview behavior

export function RHFUpload(_ref) {
  var name = _ref.name,
    helperText = _ref.helperText,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$maxFiles = _ref.maxFiles,
    maxFiles = _ref$maxFiles === void 0 ? 2 : _ref$maxFiles,
    placeholder = _ref.placeholder,
    multiFilePlaceholder = _ref.multiFilePlaceholder,
    _ref$enablePreview = _ref.enablePreview,
    enablePreview = _ref$enablePreview === void 0 ? false : _ref$enablePreview,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control,
    setValue = _useFormContext.setValue;
  var _useState = useState([]),
    uploadErrors = _useState[0],
    setUploadErrors = _useState[1];
  var _useState2 = useState([]),
    files = _useState2[0],
    setFiles = _useState2[1];
  var handleDrop = useCallback(function (acceptedFiles, fileRejections) {
    setUploadErrors([]);
    fileRejections.forEach(function (_ref2) {
      var file = _ref2.file,
        errors = _ref2.errors;
      errors.forEach(function (error) {
        setUploadErrors(function (prevErrors) {
          return [].concat(_toConsumableArray(prevErrors), [error]);
        });
      });
    });
    var newFiles = multiple ? [].concat(_toConsumableArray(files), _toConsumableArray(acceptedFiles)) : [acceptedFiles[0]];
    setValue(name, newFiles, {
      shouldValidate: true
    });
    setFiles(newFiles);
  }, [files, multiple]);
  var handleRemoveFile = function handleRemoveFile(inputFile) {
    var filesFiltered = files.filter(function (fileFiltered) {
      return fileFiltered !== inputFile;
    });
    setValue(name, filesFiltered, {
      shouldValidate: true
    });
    setFiles(filesFiltered);
  };
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref3) {
      var field = _ref3.field,
        error = _ref3.fieldState.error;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Upload, _extends({
        ref: field.ref,
        onBlur: field.onBlur,
        onDrop: handleDrop,
        multiple: multiple,
        value: multiple ? files : (files === null || files === void 0 ? void 0 : files[0]) || null,
        error: uploadErrors[0] || error,
        thumbnail: null,
        onRemove: handleRemoveFile,
        enablePreview: enablePreview,
        currentNumberOfFiles: files.length,
        maxFiles: maxFiles,
        placeholder: placeholder,
        multiFilePlaceholder: multiFilePlaceholder
      }, field, other)), helperText && /*#__PURE__*/React.createElement("span", null, helperText));
    }
  });
}